import React from 'react';
import PropTypes from 'prop-types';
import {isUndefined} from 'utils/typeUtils';
import AdministratorBCView, {
    AdministratorBCDxGrid,
    AdministratorBCMobileGrid,
    AdministratorBCDxGridContainer,
    AdministratorBCFormDialog,
    AdministratorBCForm
} from '../AdministaratorBCView';

const getDxGrid = (DxGrid) => (
    <AdministratorBCDxGridContainer component={DxGrid || <AdministratorBCDxGrid/>}/>
);

const getMobileGrid = (MobileGrid) => (
    <AdministratorBCDxGridContainer component={MobileGrid || <AdministratorBCMobileGrid/>}/>
);

const getFormDialog = (Form) => (
    <AdministratorBCFormDialog form={Form || <AdministratorBCForm/>}/>
);

const getDataTableView = ({breakpoint, administratorBCDxGrid, administratorBCMobileGrid}) => {
    if (breakpoint.down('md')) {
        return getMobileGrid(administratorBCMobileGrid);
    }
    if (isUndefined(administratorBCDxGrid) || administratorBCDxGrid) {
        return getDxGrid(administratorBCDxGrid);
    }
};

export const getAdministratorBCView = (props) => {
    const {
        breakpoint,
        administratorBCDxGrid,
        administratorBCMobileGrid,
        administratorBCForm,
        administratorBCFormDialog,
        administratorBCView,
        viewName,
        viewStyles,
        params,
    } = props;

    if (administratorBCView) return administratorBCView;

    return (
        <AdministratorBCView
            key={viewName}
            viewName={viewName}
            dataTable={getDataTableView({
                breakpoint,
                administratorBCDxGrid,
                administratorBCMobileGrid
            })}
            formDialog={administratorBCFormDialog || getFormDialog(administratorBCForm)}
            viewStyles={viewStyles}
            params={params}
        />
    )
};

getAdministratorBCView.propTypes = {
    administratorBCDxGrid: PropTypes.node,
    administratorBCForm: PropTypes.node,
    administratorBCFormDialog: PropTypes.node,
    administratorBCView: PropTypes.node,
    viewName: PropTypes.string,
};
